(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.blog-post-card').forEach((card) => {
    const img = card.querySelector('img[data-animated-src]');
    if (!img) return;

    card.addEventListener('mouseenter', () => {
      img.src = img.dataset.animatedSrc;
      img.srcset = img.dataset.animatedSrcset;
    });

    card.addEventListener('mouseleave', () => {
      const container = img.parentElement;
      if (!container) {
        img.src = img.dataset.staticSrc;
        img.srcset = img.dataset.staticSrcset;
        return;
      }

      // Create a static overlay and fade it in over the GIF
      const overlay = img.cloneNode(true);
      overlay.src = img.dataset.staticSrc;
      overlay.srcset = img.dataset.staticSrcset;
      overlay.removeAttribute('data-animated-src');
      overlay.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity 0.3s ease;z-index:1;pointer-events:none;';
      container.style.position = 'relative';
      container.appendChild(overlay);

      // Trigger reflow then fade in
      overlay.offsetHeight;
      overlay.style.opacity = '1';

      const cleanup = () => {
        if (!overlay.isConnected) return;
        img.src = img.dataset.staticSrc;
        img.srcset = img.dataset.staticSrcset;
        overlay.remove();
      };
      overlay.addEventListener('transitionend', cleanup, { once: true });
      setTimeout(cleanup, 400);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('[data-blog-layout]');
    if (!container) return;

    const rte = container.querySelector('rte-formatter');
    if (!rte) return;

    // Collect all top-level children from the rte content
    const children = Array.from(rte.childNodes).filter(
      n => n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim())
    );

    if (children.length === 0) return;

    // Check if there are any images in the content
    const hasImages = rte.querySelector('img');
    if (!hasImages) {
      // No images — render as normal blog content
      container.classList.remove('blog-post-content--structured');
      container.classList.add('blog-post-content--plain');
      return;
    }

    // Group content into sections split by images
    const sections = [];
    let currentTextNodes = [];

    function flushText() {
      if (currentTextNodes.length === 0) return null;
      const div = document.createElement('div');
      div.className = 'bpc-block__text rte';
      currentTextNodes.forEach(n => div.appendChild(n.cloneNode(true)));
      currentTextNodes = [];
      return div;
    }

    children.forEach(node => {
      const el = node.nodeType === 1 ? node : null;

      // Check if this element is or contains an image
      let img = null;
      if (el) {
        if (el.tagName === 'IMG') {
          img = el;
        } else {
          img = el.querySelector('img');
        }
      }

      if (img) {
        // Flush any accumulated text as a text-only section
        const textDiv = flushText();
        if (textDiv) {
          sections.push({ type: 'text', content: textDiv });
        }

        // Create an image section
        const imgWrapper = document.createElement('div');
        imgWrapper.className = 'bpc-block__media';
        const clonedImg = img.cloneNode(true);
        clonedImg.className = 'bpc-block__image';
        clonedImg.removeAttribute('width');
        clonedImg.removeAttribute('height');
        imgWrapper.appendChild(clonedImg);

        // Collect text nodes that follow until the next image
        sections.push({ type: 'image', content: imgWrapper });
      } else {
        currentTextNodes.push(node);
      }
    });

    // Flush remaining text
    const remaining = flushText();
    if (remaining) {
      sections.push({ type: 'text', content: remaining });
    }

    // Now build the layout: pair each image with adjacent text
    const blocks = [];
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      if (section.type === 'image') {
        // Look for text after this image
        const next = sections[i + 1];
        if (next && next.type === 'text') {
          blocks.push({ image: section.content, text: next.content });
          i++; // skip the text since we consumed it
        } else {
          // Image with no following text — look for text before
          const prev = blocks.length > 0 ? null : sections[i - 1];
          blocks.push({ image: section.content, text: null });
        }
      } else if (section.type === 'text') {
        // Standalone text (no image paired)
        blocks.push({ image: null, text: section.content });
      }
    }

    // Clear container and rebuild
    rte.innerHTML = '';
    container.classList.add('blog-post-content--has-blocks');

    blocks.forEach((block, index) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'bpc-block';

      if (block.image && block.text) {
        // Image + text pair
        wrapper.classList.add('bpc-block--pair');
        if (index % 2 === 1) {
          wrapper.classList.add('bpc-block--reversed');
        }
        wrapper.appendChild(block.image);
        wrapper.appendChild(block.text);
      } else if (block.image) {
        // Image only
        wrapper.classList.add('bpc-block--image-only');
        wrapper.appendChild(block.image);
      } else if (block.text) {
        // Text only
        wrapper.classList.add('bpc-block--text-only');
        wrapper.appendChild(block.text);
      }

      rte.appendChild(wrapper);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
